// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../addQuarters/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var addQuarters = convertToFP(fn, 2);
export default addQuarters;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/addQuarters/index.js
// module id = 816
// module chunks = 0